"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7890],{

/***/ 97890:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ List; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-properties.js
var es_object_define_properties = __webpack_require__(33321);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js
var chakra_ui_hooks_esm = __webpack_require__(97375);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 6 modules
var chakra_ui_system_esm = __webpack_require__(24614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/hooks/useObservabilitySafe.mjs + 1 modules
var useObservabilitySafe = __webpack_require__(98352);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/bricks.types.mjs
var bricks_types = __webpack_require__(26153);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/system/utils/use-style-config.mjs + 3 modules
var use_style_config = __webpack_require__(48189);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Box/Box.mjs
var Box = __webpack_require__(8013);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/SpritesheetIcons/Checkmark.mjs
var Checkmark = __webpack_require__(77972);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text = __webpack_require__(4796);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/List/AccordionListItem.mjs
var AccordionListItem = __webpack_require__(55662);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Icon/Icon.mjs + 1 modules
var Icon = __webpack_require__(49154);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Image/Image.mjs
var Image = __webpack_require__(61442);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/List/ListItem.mjs
var ListItem = __webpack_require__(73298);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/List/CardListItem.mjs
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }




















var _excluded = ["variant", "children", "accessoryIcon", "accessoryImageUrl", "accessoryImageAlt", "accessoryIconColor"];
function cov_dj3jk7c01() {
  var path = "/__w/code/code/js/packages/bricks/src/core/List/CardListItem.tsx";
  var hash = "41759c23a7d0fb4ab45fad19fc46b9594cb62343";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/List/CardListItem.tsx",
    statementMap: {
      "0": {
        start: {
          line: 39,
          column: 57
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "1": {
        start: {
          line: 48,
          column: 17
        },
        end: {
          line: 51,
          column: 4
        }
      },
      "2": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 75,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 39,
            column: 57
          },
          end: {
            line: 39,
            column: 58
          }
        },
        loc: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 47
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 59,
            column: 9
          },
          end: {
            line: 63,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 9
          },
          end: {
            line: 59,
            column: 22
          }
        }, {
          start: {
            line: 60,
            column: 10
          },
          end: {
            line: 62,
            column: 16
          }
        }],
        line: 59
      },
      "1": {
        loc: {
          start: {
            line: 64,
            column: 9
          },
          end: {
            line: 70,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 9
          },
          end: {
            line: 64,
            column: 26
          }
        }, {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 69,
            column: 12
          }
        }],
        line: 64
      },
      "2": {
        loc: {
          start: {
            line: 68,
            column: 17
          },
          end: {
            line: 68,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 17
          },
          end: {
            line: 68,
            column: 34
          }
        }, {
          start: {
            line: 68,
            column: 38
          },
          end: {
            line: 68,
            column: 40
          }
        }],
        line: 68
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "41759c23a7d0fb4ab45fad19fc46b9594cb62343"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_dj3jk7c01 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_dj3jk7c01();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







/**
 * CardListItem should only be used as a child of a List component with
 * variant="card"
 */
cov_dj3jk7c01().s[0]++;
var CardListItem = function CardListItem(_ref) {
  var _ref2;
  var variant = _ref.variant,
    children = _ref.children,
    accessoryIcon = _ref.accessoryIcon,
    accessoryImageUrl = _ref.accessoryImageUrl,
    accessoryImageAlt = _ref.accessoryImageAlt,
    accessoryIconColor = _ref.accessoryIconColor,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_dj3jk7c01().f[0]++;
  var styles = (cov_dj3jk7c01().s[1]++, (0,use_style_config/* useMultiStyleConfig */.jC)('CardListItem', _objectSpread({
    variant: variant
  }, props)));
  cov_dj3jk7c01().s[2]++;
  return /*#__PURE__*/react.createElement(ListItem/* ListItem */.H
  // __css has a lower priority than sx
  , _extends({
    __css: styles.listItem
  }, props), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    __css: styles.content
  }, (cov_dj3jk7c01().b[0][0]++, accessoryIcon) && (cov_dj3jk7c01().b[0][1]++, /*#__PURE__*/react.createElement(Box/* default */.Z, {
    as: "span",
    __css: styles.accessoryIconContainer
  }, /*#__PURE__*/react.createElement(Icon/* default */.Z, {
    __css: styles.accessoryIcon,
    name: accessoryIcon,
    color: accessoryIconColor
  }))), (cov_dj3jk7c01().b[1][0]++, accessoryImageUrl) && (cov_dj3jk7c01().b[1][1]++, /*#__PURE__*/react.createElement(Image/* default */.Z, {
    __css: styles.accessoryImage,
    src: accessoryImageUrl,
    alt: (_ref2 = (cov_dj3jk7c01().b[2][0]++, accessoryImageAlt)) !== null && _ref2 !== void 0 ? _ref2 : (cov_dj3jk7c01().b[2][1]++, '')
  })), children), /*#__PURE__*/react.createElement(Icon/* default */.Z, {
    __css: styles.chevron,
    name: "chevron-right",
    size: 16,
    "aria-hidden": true
  }));
};
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/List/List.mjs
function List_typeof(o) { "@babel/helpers - typeof"; return List_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, List_typeof(o); }




















var List_excluded = ["title", "children", "spacing", "variant"],
  _excluded2 = ["analyticsName", "trackImpression"],
  _excluded3 = ["variant", "children", "analyticsName"];
function cov_2oyaww95a7() {
  var path = "/__w/code/code/js/packages/bricks/src/core/List/List.tsx";
  var hash = "d37173482c103d2244451251f5424738ac37eec8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/List/List.tsx",
    statementMap: {
      "0": {
        start: {
          line: 62,
          column: 87
        },
        end: {
          line: 92,
          column: 2
        }
      },
      "1": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 93
        }
      },
      "2": {
        start: {
          line: 68,
          column: 17
        },
        end: {
          line: 68,
          column: 84
        }
      },
      "3": {
        start: {
          line: 70,
          column: 19
        },
        end: {
          line: 70,
          column: 52
        }
      },
      "4": {
        start: {
          line: 71,
          column: 27
        },
        end: {
          line: 71,
          column: 47
        }
      },
      "5": {
        start: {
          line: 72,
          column: 18
        },
        end: {
          line: 72,
          column: 78
        }
      },
      "6": {
        start: {
          line: 73,
          column: 23
        },
        end: {
          line: 73,
          column: 69
        }
      },
      "7": {
        start: {
          line: 74,
          column: 34
        },
        end: {
          line: 74,
          column: 99
        }
      },
      "8": {
        start: {
          line: 76,
          column: 24
        },
        end: {
          line: 76,
          column: 63
        }
      },
      "9": {
        start: {
          line: 76,
          column: 38
        },
        end: {
          line: 76,
          column: 52
        }
      },
      "10": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 91,
          column: 4
        }
      },
      "11": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 104,
          column: 1
        }
      },
      "12": {
        start: {
          line: 100,
          column: 22
        },
        end: {
          line: 100,
          column: 99
        }
      },
      "13": {
        start: {
          line: 101,
          column: 22
        },
        end: {
          line: 101,
          column: 50
        }
      },
      "14": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 71
        }
      },
      "15": {
        start: {
          line: 128,
          column: 41
        },
        end: {
          line: 202,
          column: 1
        }
      },
      "16": {
        start: {
          line: 130,
          column: 30
        },
        end: {
          line: 179,
          column: 6
        }
      },
      "17": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 134,
          column: 7
        }
      },
      "18": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 21
        }
      },
      "19": {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 156,
          column: 7
        }
      },
      "20": {
        start: {
          line: 138,
          column: 21
        },
        end: {
          line: 138,
          column: 97
        }
      },
      "21": {
        start: {
          line: 140,
          column: 8
        },
        end: {
          line: 144,
          column: 9
        }
      },
      "22": {
        start: {
          line: 143,
          column: 10
        },
        end: {
          line: 143,
          column: 23
        }
      },
      "23": {
        start: {
          line: 146,
          column: 8
        },
        end: {
          line: 148,
          column: 9
        }
      },
      "24": {
        start: {
          line: 147,
          column: 10
        },
        end: {
          line: 147,
          column: 98
        }
      },
      "25": {
        start: {
          line: 151,
          column: 8
        },
        end: {
          line: 155,
          column: 11
        }
      },
      "26": {
        start: {
          line: 159,
          column: 6
        },
        end: {
          line: 168,
          column: 7
        }
      },
      "27": {
        start: {
          line: 160,
          column: 21
        },
        end: {
          line: 160,
          column: 92
        }
      },
      "28": {
        start: {
          line: 161,
          column: 8
        },
        end: {
          line: 165,
          column: 9
        }
      },
      "29": {
        start: {
          line: 164,
          column: 10
        },
        end: {
          line: 164,
          column: 23
        }
      },
      "30": {
        start: {
          line: 167,
          column: 8
        },
        end: {
          line: 167,
          column: 20
        }
      },
      "31": {
        start: {
          line: 171,
          column: 19
        },
        end: {
          line: 171,
          column: 86
        }
      },
      "32": {
        start: {
          line: 172,
          column: 6
        },
        end: {
          line: 176,
          column: 7
        }
      },
      "33": {
        start: {
          line: 175,
          column: 8
        },
        end: {
          line: 175,
          column: 21
        }
      },
      "34": {
        start: {
          line: 178,
          column: 6
        },
        end: {
          line: 178,
          column: 18
        }
      },
      "35": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 191,
          column: 5
        }
      },
      "36": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 190,
          column: 8
        }
      },
      "37": {
        start: {
          line: 192,
          column: 4
        },
        end: {
          line: 200,
          column: 6
        }
      },
      "38": {
        start: {
          line: 204,
          column: 24
        },
        end: {
          line: 210,
          column: 1
        }
      },
      "39": {
        start: {
          line: 205,
          column: 2
        },
        end: {
          line: 209,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 65,
            column: 2
          },
          end: {
            line: 65,
            column: 3
          }
        },
        loc: {
          start: {
            line: 65,
            column: 77
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 65
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 76,
            column: 32
          },
          end: {
            line: 76,
            column: 33
          }
        },
        loc: {
          start: {
            line: 76,
            column: 38
          },
          end: {
            line: 76,
            column: 52
          }
        },
        line: 76
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        },
        loc: {
          start: {
            line: 99,
            column: 57
          },
          end: {
            line: 103,
            column: 3
          }
        },
        line: 99
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 129,
            column: 2
          },
          end: {
            line: 129,
            column: 3
          }
        },
        loc: {
          start: {
            line: 129,
            column: 59
          },
          end: {
            line: 201,
            column: 3
          }
        },
        line: 129
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 130,
            column: 59
          },
          end: {
            line: 130,
            column: 60
          }
        },
        loc: {
          start: {
            line: 130,
            column: 70
          },
          end: {
            line: 179,
            column: 5
          }
        },
        line: 130
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 204,
            column: 24
          },
          end: {
            line: 204,
            column: 25
          }
        },
        loc: {
          start: {
            line: 204,
            column: 97
          },
          end: {
            line: 210,
            column: 1
          }
        },
        line: 204
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 67,
            column: 55
          },
          end: {
            line: 67,
            column: 88
          }
        }, {
          start: {
            line: 67,
            column: 91
          },
          end: {
            line: 67,
            column: 93
          }
        }],
        line: 67
      },
      "1": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 67,
            column: 27
          }
        }, {
          start: {
            line: 67,
            column: 31
          },
          end: {
            line: 67,
            column: 52
          }
        }],
        line: 67
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 27
          },
          end: {
            line: 71,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 27
          },
          end: {
            line: 71,
            column: 42
          }
        }, {
          start: {
            line: 71,
            column: 46
          },
          end: {
            line: 71,
            column: 47
          }
        }],
        line: 71
      },
      "3": {
        loc: {
          start: {
            line: 72,
            column: 18
          },
          end: {
            line: 72,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 72,
            column: 44
          },
          end: {
            line: 72,
            column: 60
          }
        }, {
          start: {
            line: 72,
            column: 63
          },
          end: {
            line: 72,
            column: 78
          }
        }],
        line: 72
      },
      "4": {
        loc: {
          start: {
            line: 73,
            column: 23
          },
          end: {
            line: 73,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 33
          },
          end: {
            line: 73,
            column: 64
          }
        }, {
          start: {
            line: 73,
            column: 67
          },
          end: {
            line: 73,
            column: 69
          }
        }],
        line: 73
      },
      "5": {
        loc: {
          start: {
            line: 74,
            column: 34
          },
          end: {
            line: 74,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 74,
            column: 88
          },
          end: {
            line: 74,
            column: 92
          }
        }, {
          start: {
            line: 74,
            column: 95
          },
          end: {
            line: 74,
            column: 99
          }
        }],
        line: 74
      },
      "6": {
        loc: {
          start: {
            line: 80,
            column: 7
          },
          end: {
            line: 80,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 7
          },
          end: {
            line: 80,
            column: 12
          }
        }, {
          start: {
            line: 80,
            column: 16
          },
          end: {
            line: 80,
            column: 57
          }
        }],
        line: 80
      },
      "7": {
        loc: {
          start: {
            line: 82,
            column: 39
          },
          end: {
            line: 82,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 57
          },
          end: {
            line: 82,
            column: 76
          }
        }, {
          start: {
            line: 82,
            column: 79
          },
          end: {
            line: 82,
            column: 81
          }
        }],
        line: 82
      },
      "8": {
        loc: {
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      },
      "9": {
        loc: {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 156,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 156,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 137
      },
      "10": {
        loc: {
          start: {
            line: 140,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 140,
            column: 8
          },
          end: {
            line: 144,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 140
      },
      "11": {
        loc: {
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 146
      },
      "12": {
        loc: {
          start: {
            line: 146,
            column: 12
          },
          end: {
            line: 146,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 146,
            column: 12
          },
          end: {
            line: 146,
            column: 41
          }
        }, {
          start: {
            line: 146,
            column: 45
          },
          end: {
            line: 146,
            column: 79
          }
        }],
        line: 146
      },
      "13": {
        loc: {
          start: {
            line: 153,
            column: 25
          },
          end: {
            line: 153,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 153,
            column: 25
          },
          end: {
            line: 153,
            column: 38
          }
        }, {
          start: {
            line: 153,
            column: 42
          },
          end: {
            line: 153,
            column: 60
          }
        }],
        line: 153
      },
      "14": {
        loc: {
          start: {
            line: 159,
            column: 6
          },
          end: {
            line: 168,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 159,
            column: 6
          },
          end: {
            line: 168,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 159
      },
      "15": {
        loc: {
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 165,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 161,
            column: 8
          },
          end: {
            line: 165,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 161
      },
      "16": {
        loc: {
          start: {
            line: 172,
            column: 6
          },
          end: {
            line: 176,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 6
          },
          end: {
            line: 176,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 172
      },
      "17": {
        loc: {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 191,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 191,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 181
      },
      "18": {
        loc: {
          start: {
            line: 181,
            column: 8
          },
          end: {
            line: 181,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 181,
            column: 8
          },
          end: {
            line: 181,
            column: 31
          }
        }, {
          start: {
            line: 181,
            column: 35
          },
          end: {
            line: 181,
            column: 62
          }
        }],
        line: 181
      },
      "19": {
        loc: {
          start: {
            line: 206,
            column: 16
          },
          end: {
            line: 206,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 206,
            column: 16
          },
          end: {
            line: 206,
            column: 30
          }
        }, {
          start: {
            line: 206,
            column: 34
          },
          end: {
            line: 206,
            column: 47
          }
        }],
        line: 206
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d37173482c103d2244451251f5424738ac37eec8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2oyaww95a7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2oyaww95a7();
function List_extends() { List_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return List_extends.apply(this, arguments); }



function List_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function List_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? List_ownKeys(Object(t), !0).forEach(function (r) { List_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : List_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function List_defineProperty(obj, key, value) { key = List_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function List_toPropertyKey(t) { var i = List_toPrimitive(t, "string"); return "symbol" == List_typeof(i) ? i : String(i); }
function List_toPrimitive(t, r) { if ("object" != List_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != List_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function List_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = List_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function List_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }













//TO DO: Unmute console.error's
// Unfortunately, errors related to children are triggered if the exact ListItem is not passed as a children - so we are muting these for now

var BaseList = (cov_2oyaww95a7().s[0]++, (0,chakra_ui_system_esm/* forwardRef */.Gp)(function (_ref, ref) {
  var _ref2;
  var title = _ref.title,
    children = _ref.children,
    spacingOverride = _ref.spacing,
    variant = _ref.variant,
    props = List_objectWithoutProperties(_ref, List_excluded);
  cov_2oyaww95a7().f[0]++;
  var dataURIProps = (cov_2oyaww95a7().s[1]++, (cov_2oyaww95a7().b[1][0]++, variant === 'checklist') && (cov_2oyaww95a7().b[1][1]++, 'customIcon' in props) ? (cov_2oyaww95a7().b[0][0]++, getDataURIProps(props.customIcon)) : (cov_2oyaww95a7().b[0][1]++, {}));
  var styles = (cov_2oyaww95a7().s[2]++, (0,use_style_config/* useMultiStyleConfig */.jC)('List', List_objectSpread(List_objectSpread({
    variant: variant
  }, props), dataURIProps)));
  // Selector applies style to all list item children EXCEPT the first one
  var selector = (cov_2oyaww95a7().s[3]++, '& > *:not(style) ~ *:not(style)');
  var accordionSpacing = (cov_2oyaww95a7().s[4]++, (_ref2 = (cov_2oyaww95a7().b[2][0]++, spacingOverride)) !== null && _ref2 !== void 0 ? _ref2 : (cov_2oyaww95a7().b[2][1]++, 3));
  var spacing = (cov_2oyaww95a7().s[5]++, variant === 'accordion' ? (cov_2oyaww95a7().b[3][0]++, accordionSpacing) : (cov_2oyaww95a7().b[3][1]++, spacingOverride));
  var spacingStyle = (cov_2oyaww95a7().s[6]++, spacing ? (cov_2oyaww95a7().b[4][0]++, List_defineProperty({}, selector, {
    mt: spacing
  })) : (cov_2oyaww95a7().b[4][1]++, {}));
  var asProp = (cov_2oyaww95a7().s[7]++, ['numbered', 'decimal'].includes(variant) ? (cov_2oyaww95a7().b[5][0]++, 'ol') : (cov_2oyaww95a7().b[5][1]++, 'ul'));
  // Determines whether or not List is an ordered or unordered list
  var ListComponent = (cov_2oyaww95a7().s[8]++, (0,react.useMemo)(function () {
    cov_2oyaww95a7().f[1]++;
    cov_2oyaww95a7().s[9]++;
    return (0,bricks_types/* bricks */.G)(asProp);
  }, [asProp]));
  cov_2oyaww95a7().s[10]++;
  return /*#__PURE__*/react.createElement(Box/* default */.Z, {
    __css: styles.container
  }, (cov_2oyaww95a7().b[6][0]++, title) && (cov_2oyaww95a7().b[6][1]++, /*#__PURE__*/react.createElement(Text/* default */.Z, {
    __css: styles.title
  }, title)), /*#__PURE__*/react.createElement(ListComponent, List_extends({
    "data-testid": "list-".concat(variant).concat('size' in props ? (cov_2oyaww95a7().b[7][0]++, "-".concat(props['size'])) : (cov_2oyaww95a7().b[7][1]++, '')),
    ref: ref
    // __css has a lower priority than sx
    ,
    __css: List_objectSpread(List_objectSpread({}, styles.list), spacingStyle)
  }, props), children));
}));
var AccordionListWithTracking = (cov_2oyaww95a7().s[11]++, (0,chakra_ui_system_esm/* forwardRef */.Gp)(function (_ref4, ref) {
  var analyticsName = _ref4.analyticsName,
    trackImpression = _ref4.trackImpression,
    props = List_objectWithoutProperties(_ref4, _excluded2);
  cov_2oyaww95a7().f[2]++;
  var inViewRef = (cov_2oyaww95a7().s[12]++, (0,useObservabilitySafe/* useTrackComponentInView */.O)('accordionViewEvent', trackImpression, analyticsName));
  var mergedRef = (cov_2oyaww95a7().s[13]++, (0,chakra_ui_hooks_esm/* useMergeRefs */.qq)(ref, inViewRef));
  cov_2oyaww95a7().s[14]++;
  return /*#__PURE__*/react.createElement(BaseList, List_extends({
    variant: "accordion",
    ref: mergedRef
  }, props));
}));

/**
 * Lists are continuous, vertical indexes of bulleted or numbered lists, cards,
 * accordions, or other related content.
 *
 * List variant variations
 * ------------------------------------------------------------------------------------------------
 *
 * "text"
 *
 * "bullet"
 *
 * "checklist"
 *
 * "numbered"
 *
 * List size variations
 * --------------------------------------------------------------------------------------------------------
 *
 * "standard"
 *
 * "compact"
 */
var List = (cov_2oyaww95a7().s[15]++, (0,chakra_ui_system_esm/* forwardRef */.Gp)(function (_ref5, ref) {
  var variant = _ref5.variant,
    children = _ref5.children,
    analyticsName = _ref5.analyticsName,
    props = List_objectWithoutProperties(_ref5, _excluded3);
  cov_2oyaww95a7().f[3]++;
  var validatedChildren = (cov_2oyaww95a7().s[16]++, react.Children.map(children, function (child) {
    cov_2oyaww95a7().f[4]++;
    cov_2oyaww95a7().s[17]++;
    // Checking isValidElement is the safe way and avoids a typescript error too.
    if (! /*#__PURE__*/react.isValidElement(child)) {
      cov_2oyaww95a7().b[8][0]++;
      cov_2oyaww95a7().s[18]++;
      return child;
    } else {
      cov_2oyaww95a7().b[8][1]++;
    }

    // Validate accordion list variant only has AccordionListItem children
    cov_2oyaww95a7().s[19]++;
    if (variant === 'accordion') {
      var _ref6;
      cov_2oyaww95a7().b[9][0]++;
      var _item = (cov_2oyaww95a7().s[20]++, child);
      cov_2oyaww95a7().s[21]++;
      if (_item.type !== AccordionListItem/* AccordionListItem */.rB) {
        cov_2oyaww95a7().b[10][0]++;
        cov_2oyaww95a7().s[22]++;
        // eslint-disable-next-line no-console
        // console.error('Accordion lists should only contain AccordionListItem children');
        return child;
      } else {
        cov_2oyaww95a7().b[10][1]++;
      }
      cov_2oyaww95a7().s[23]++;
      if ((cov_2oyaww95a7().b[12][0]++, _item.props.size === 'compact') && (cov_2oyaww95a7().b[12][1]++, _item.props.variant !== 'secondary')) {
        cov_2oyaww95a7().b[11][0]++;
        cov_2oyaww95a7().s[24]++;
        throw new Error('Compact sizes are only supported on secondary variant accordion list');
      } else {
        cov_2oyaww95a7().b[11][1]++;
      }

      // Injects analyticsName and padding into children when variant is accordion
      cov_2oyaww95a7().s[25]++;
      return /*#__PURE__*/react.cloneElement(_item, {
        noPadding: props.size === 'compact',
        analyticsName: (_ref6 = (cov_2oyaww95a7().b[13][0]++, analyticsName)) !== null && _ref6 !== void 0 ? _ref6 : (cov_2oyaww95a7().b[13][1]++, _item.props.panelId),
        boxShadow: props.boxShadow
      });
    } else {
      cov_2oyaww95a7().b[9][1]++;
    }

    // Validate card list variant only has CardListItem children
    cov_2oyaww95a7().s[26]++;
    if (variant === 'card') {
      cov_2oyaww95a7().b[14][0]++;
      var _item2 = (cov_2oyaww95a7().s[27]++, child);
      cov_2oyaww95a7().s[28]++;
      if (_item2.type !== CardListItem) {
        cov_2oyaww95a7().b[15][0]++;
        cov_2oyaww95a7().s[29]++;
        // eslint-disable-next-line no-console
        // console.error('Card lists should only contain CardListItem children');
        return child;
      } else {
        cov_2oyaww95a7().b[15][1]++;
      }
      cov_2oyaww95a7().s[30]++;
      return _item2;
    } else {
      cov_2oyaww95a7().b[14][1]++;
    }

    // Validate all other list variants only have ListItem children
    var item = (cov_2oyaww95a7().s[31]++, child);
    cov_2oyaww95a7().s[32]++;
    if (item.type !== ListItem/* ListItem */.H) {
      cov_2oyaww95a7().b[16][0]++;
      cov_2oyaww95a7().s[33]++;
      // eslint-disable-next-line no-console
      // console.error('Lists should only contain ListItem children');
      return child;
    } else {
      cov_2oyaww95a7().b[16][1]++;
    }
    cov_2oyaww95a7().s[34]++;
    return item;
  }));
  cov_2oyaww95a7().s[35]++;
  if ((cov_2oyaww95a7().b[18][0]++, variant === 'accordion') && (cov_2oyaww95a7().b[18][1]++, analyticsName !== undefined)) {
    cov_2oyaww95a7().b[17][0]++;
    cov_2oyaww95a7().s[36]++;
    return /*#__PURE__*/react.createElement(AccordionListWithTracking, List_extends({
      ref: ref
      // eslint-disable-next-line react/no-children-prop
      ,
      children: validatedChildren,
      analyticsName: analyticsName
    }, props));
  } else {
    cov_2oyaww95a7().b[17][1]++;
  }
  cov_2oyaww95a7().s[37]++;
  return /*#__PURE__*/react.createElement(BaseList
  // eslint-disable-next-line react/no-children-prop
  , List_extends({
    children: validatedChildren,
    ref: ref,
    variant: variant
  }, props));
}));
cov_2oyaww95a7().s[38]++;
var getDataURIProps = function getDataURIProps(customIcon) {
  var _ref7;
  cov_2oyaww95a7().f[5]++;
  cov_2oyaww95a7().s[39]++;
  return {
    dataURISVG: (_ref7 = (cov_2oyaww95a7().b[19][0]++, customIcon.svg)) !== null && _ref7 !== void 0 ? _ref7 : (cov_2oyaww95a7().b[19][1]++, Checkmark/* default.svg */.Z.svg),
    dataURISVGColor: customIcon === null || customIcon === void 0 ? void 0 : customIcon.color,
    dataURISVGSize: customIcon === null || customIcon === void 0 ? void 0 : customIcon.size
  };
};

/***/ })

}]);